import { useEffect, useState } from 'react'

import { triggerBlobDownload } from '~/utils/utilityFunctions'

import ReactGA from '~/lib/analytics'
import { useDownloadStat } from '~/lib/stats'

export default function useDownload() {
  const { mutateAsync, data: downloadData, status } = useDownloadStat()
  const [fileType, setFileType] = useState<null | 'pdf' | 'ppt'>(null)
  const [error, setError] = useState(null)

  const downloadStat = (id: string, type: 'pdf' | 'ppt') => {
    mutateAsync(id)
    setFileType(type)
  }

  useEffect(() => {
    if (downloadData) {
      const fileLink = fileType === 'ppt' ? downloadData.url_pptx : downloadData.url_pdf

      fetch(fileLink, {
        method: 'GET',
      }).then((res) => {
        if (res.status !== 200) {
          // eslint-disable-next-line no-console
          console.log('Failed to download file:', res)
          setError('Failed to download file')
          return
        }
        res
          .blob()
          .then((blob) => {
            ReactGA.event({ action: 'file_download', category: 'engagement', label: fileType })
            // eslint-disable-next-line no-console
            console.log('Downloading blob:', blob, fileLink)
            const title = fileLink.match(/\/.*\/(\S*)_.*\?/)[1]
            const split = title.split('_')
            const finalTitle = `report_${split[0]}_${split[1]}`
            triggerBlobDownload(blob, finalTitle)
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('Error parsing blob:', err)
            setError(err)
          })
      })
    }
  }, [downloadData, fileType])

  return { downloadStat, status, error, setError }
}
